'use strict';
var global = require('../internals/global');

module.exports = global;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/path.js
// module id = 248
// module chunks = 0